/** @format */

import React from "react";
import { useState, useEffect } from "react";
import {
  Routes,
  Route,
  Link,
  useNavigate,
  useLocation,
  Navigate,
  Outlet,
} from "react-router-dom";
import { UserOutlined } from "@ant-design/icons";
import { Col, Divider, Dropdown, MenuProps, Popover, Row, Tooltip, Typography } from "antd";
import { LogoutOutlined, SettingOutlined, DownOutlined } from "@ant-design/icons";

import "./App.css";

import * as AuthService from "./services/auth.service";
import IUser from "./types/user.type";

import Login from "./components/Login";
import Home from "./components/Home";
import EventBus from "./common/EventBus";

import {
  Breadcrumb,
  Layout,
  Menu,
  theme,
  Image,
  Space,
  Button,
  Avatar,
} from "antd";
import {
  ReloadOutlined,
  CloseCircleFilled,
  CheckCircleFilled,
  ClockCircleOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";

const { Header, Content, Footer } = Layout;
const { Text } = Typography;
const App: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // const [showModeratorBoard, setShowModeratorBoard] = useState<boolean>(false);
  // const [showAdminBoard, setShowAdminBoard] = useState<boolean>(false);
  const [currentUser, setCurrentUser] = useState<IUser | undefined>(undefined);
  const [isloggedIn, setIsLoggedIn] = useState(false);

  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user"))
  );

  console.log(userDetails);

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    const logged = localStorage.getItem("access_token") ? true : false;
    setIsLoggedIn(logged);
    console.log(user);

    if (user) {
      setCurrentUser(user);
      // setShowModeratorBoard(user.roles.includes("ROLE_MODERATOR"));
      // setShowAdminBoard(user.roles.includes("ROLE_ADMIN"));
    }

    EventBus.on("logout", logOut);

    return () => {
      EventBus.remove("logout", logOut);
    };
  }, []);

  const logOut = () => {
    AuthService.logout();
    // setShowModeratorBoard(false);
    // setShowAdminBoard(false);
    setCurrentUser(undefined);
  };
  const logoutUser = () => {
    console.log("logging out");
    localStorage.clear();
    window.location.href = "https://urlrecat.auth.us-east-1.amazoncognito.com/logout?client_id=3592ngtbal2vd8cn6sh5d9n3hb&logout_uri=https://urlcat.sase-swg-dev.juniperclouds.net&redirect_uri=https://urlcat.sase-swg-dev.juniperclouds.net&response_type=token"; 
  };
  const renderUserHeader = () => {
    return (
      <div style={{ width: "200px" }}>
        User Info
        <Tooltip placement='bottom' title='Logout'>
          <LogoutOutlined
            style={{
              color: "#0094ff",
              float: "right",
              marginTop: "2px",
              fontSize: "18px",
            }}
            onClick={logoutUser}
          />
        </Tooltip>
      </div>
    );
  };
  const items: MenuProps['items'] = [
  {
    key: '1',
    label: (
     <span>User info</span>
    ),
  },
  {
    key: '2',
    label: (
      <label>{currentUser?.email}</label>
    )
  },
  {
    key: '3',
    label: (
      <span onClick={logoutUser}>
      <LogoutOutlined
      style={{
        color: "#0094ff",
        float: "right",
        marginTop: "2px",
        fontSize: "18px",
      }}
      
    />
       Logout
      </span>
    )
  },
];
const AuthWrapper = () => {
  const location = useLocation(); // current location

  const userLogged = localStorage.getItem("access_token") ? true : false;

  return userLogged
    ? <Outlet />
    : (
      <Navigate
        to="/login"
        replace
        state={{ from: location }} // <-- pass location in route state
      />
    );
};
  const userContent = (data: any) => {
    return (
      <div>
        <strong>Email:</strong> {currentUser?.email}
      </div>
    );
  };
  return (
    <Layout className='layout'>
      <Header
        className='header'
        style={{ display: "flex", alignItems: "center" }}
      >
        <div className='demo-logo'>
          <Image
            width={100}
            src='https://juniper-prod.scene7.com/is/image/junipernetworks/juniper_black-rgb-header?wid=320&dpr=off'
            preview={false}
          />
        </div>
        <div className='brand'>
          Security Director Cloud - URL Recategorization
        </div>

        {isloggedIn && <div className='profile-icon'>
          {location.pathname !== "/login" && (
            <Dropdown menu={{ items, selectable: false }} trigger={['click']} >
              <div>
              <Avatar
                size={25}
                onClick={(e) => e.preventDefault()}
                className='profile-avatar'
                style={{ backgroundColor: "#448400" }}
                icon={<UserOutlined />}
              />
              <label className="user-label">{currentUser?.email}</label>
              <DownOutlined />
              </div>
          </Dropdown>
/*             <Popover
              key='user-details'
              content={
                window?.localStorage?.user ? (
                  userContent(JSON.parse(window?.localStorage?.user))
                ) : (
                  <></>
                )
              }
              title={renderUserHeader()}
              placement='bottomRight'
            >
              <Avatar
                className='profile-avatar'
                style={{ backgroundColor: "#448400" }}
                icon={<UserOutlined />}
              />
            </Popover> */
          )}
        </div>}
        {/* <div className="userSpace">
          <Space>
            <Button type="link"><ReloadOutlined /></Button>
          </Space>
        </div> */}
      </Header>
      <Content>
        {/* <Breadcrumb style={{ margin: '16px 0' }}>
          <Breadcrumb.Item>Home</Breadcrumb.Item>
          <Breadcrumb.Item>List</Breadcrumb.Item>
          <Breadcrumb.Item>App</Breadcrumb.Item>
        </Breadcrumb> */}
        <div className='site-layout-content'>
          <Routes>
            <Route path='/' element={<Login />} />
            <Route path='/login' element={<Login />} />

            <Route element={<AuthWrapper />}>
              <Route path={"/dashboard"} element={<Home />} />
            </Route>

            {/* <Route path="/register" element={<Register />} /> */}
            {/* <Route path="/new-request" element={<Profile />} /> */}
            {/* <Route path="/user" element={<BoardUser />} />
          <Route path="/mod" element={<BoardModerator />} />
          <Route path="/admin" element={<BoardAdmin />} /> */}
          </Routes>
        </div>
        <Footer style={{ textAlign: "center" }}>Juniper Networks ©2023</Footer>
      </Content>
    </Layout>
    // <div>
    //   <nav className="navbar navbar-expand">
    //     <Image src="juniper-logo.png" rounded />
    //     <Link to={"/"} className="navbar-brand">
    //       Security Director Cloud - URL Recategorization
    //     </Link>
    //     <div className="navbar-nav mr-auto">

    //       {/* {showModeratorBoard && (
    //         <li className="nav-item">
    //         <Link to={"/mod"} className="nav-link">
    //         Moderator Board
    //         </Link>
    //         </li>
    //         )}

    //         {showAdminBoard && (
    //           <li className="nav-item">
    //           <Link to={"/admin"} className="nav-link">
    //           Admin Board
    //           </Link>
    //           </li>
    //         )} */}

    //       {/* {currentUser && (
    //         <>
    //           <li className="nav-item">
    //             <Link to={"/dashboard"} className="nav-link">
    //               Dashboard
    //             </Link>
    //           </li>
    //         </>
    //       )} */}
    //     </div>

    //     {currentUser && (
    //       <div className="navbar-nav ml-auto">
    //         <li className="nav-item">
    //           <Link to={"/profile"} className="nav-link">
    //             {currentUser.username}
    //           </Link>
    //         </li>
    //         <li className="nav-item">
    //           <a href="/logout" className="nav-link" onClick={logOut}>
    //             Logout
    //           </a>
    //         </li>
    //       </div>
    //     )}
    //   </nav>

    //   <div className="container mt-3">

    //   </div>
    // </div>
  );
};

export default App;
